import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { HttpParamsBuilder, RestClientPaged } from '@elderbyte/ngx-starter'
import { Observable } from 'rxjs'
import { environment } from '../../../../environments/environment'
import { StorageGroup } from './storage-group'

@Injectable({
  providedIn: 'root',
})
export class StorageGroupService extends RestClientPaged<StorageGroup, string> {
  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)

    super(environment.apiPath + '/storage/groups', http, {
      idField: 'id',
    })
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public findOneByPackageNumber(packageNumber: string): Observable<StorageGroup> {
    const params = HttpParamsBuilder.start().append('packageNumber', packageNumber).build()

    return this.http.get<StorageGroup>(this.restEndpoint + '/one', { params: params })
  }
}
